import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => {
    return {
        dialogPaper: {
            width: '35%'
        },
        actionSpacer: {
            marginRight: theme.spacing(2),
        },
    }
}, { index: 1 });